__turbopack_context__.v({
  "SHeartSvg": "LInAKG_SHeartSvg",
});
